<script>
import { Btn, BtnGroup, BtnToolbar } from "uiv";
import { mapMutations, mapGetters } from "vuex";
import Placeholder from "./Placeholder/Barra";

export default {
  components: { Btn, BtnGroup, BtnToolbar, Placeholder },
  methods: { ...mapMutations(["setResultadoView", "setMoneda"]) },
  computed: { ...mapGetters(["isMaster", "isResultadosView", "getMoneda"]) },
  data() {
    return {
      orden: this.$store.getters.getOrden,
      moneda: this.$store.getters.getMoneda,
    };
  },
  watch: {
    orden(payload) {
      this.$store.commit("setOrden", payload);
    },
    moneda(payload) {
      if (!payload) {
        this.orden = 0;
      }
      this.$store.commit("setMoneda", payload);
    },
  },
};
</script>

<template>
  <div id="barra">
    <div class="panel panel-default" v-if="isMaster">
      <div class="panel-body">
        <div class="row">
          <div class="form-group form-group-sm col-xs-2 col-sm-2 col-md-2">
            <label>
              <i class="fa fa-sort hidden-xs"></i> Ordenar
              <span class="hidden-xs">por</span>:
            </label>
          </div>

          <div class="form-group form-group-sm col-xs-4 col-sm-3 col-md-3">
            <select class="form-control" v-model="orden">
              <option :value="0">Destacados</option>
              <option :value="1">Nombre</option>
              <option :value="2">Precio: Menor a Mayor</option>
              <option :value="3">Precio: Mayor a Menor</option>
            </select>
          </div>

          <div class="form-group form-group-sm col-xs-2 col-sm-2 col-md-2">
            <label>
              <i class="fa fa-money hidden-xs"></i> Moneda:
            </label>
          </div>

          <div class="form-group form-group-sm col-xs-4 col-sm-3 col-md-3">
            <select class="form-control" v-model="moneda">
              <option value>Moneda de Origen</option>
              <option value="ARS">Peso Argentino</option>
              <option value="USD">Dolar Estadounidense</option>
              <option value="EUR">Euro</option>
            </select>
          </div>

          <div class="form-group col-xs-2 col-sm-2 col-md-2 hidden-xs">
            <btn-toolbar>
              <btn-group size="sm" justified>
                <btn size="sm" @click="setResultadoView(1)" :active="isResultadosView(1)" justified>
                  <i class="fa fa-th-list"></i>
                </btn>
                <btn size="sm" @click="setResultadoView(2)" :active="isResultadosView(2)" justified>
                  <i class="fa fa-th-large"></i>
                </btn>
                <btn size="sm" @click="setResultadoView(3)" :active="isResultadosView(3)" justified>
                  <i class="fa fa-bars"></i>
                </btn>
              </btn-group>
            </btn-toolbar>
          </div>
        </div>
      </div>
    </div>
    <placeholder v-else></placeholder>
  </div>
</template>

<style lang="scss" scoped>
#barra .panel {
  border: 0;
  > .panel-body {
    padding: 10px;
    > .row {
      margin-right: -5px;
      margin-left: -5px;
      > .form-group {
        padding-right: 5px;
        padding-left: 5px;
        margin-bottom: 0;
        > label {
          display: block;
          text-align: right;
          margin: 5px 0;
        }
        > .form-control {
          padding: 5px 15px 5px 0;
          font-style: normal;
          cursor: pointer;
          border: 0;
          box-shadow: none;
        }
      }
    }
  }
}
</style>